//httpConfig.interceptor.ts
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, tap, finalize  } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { GlobalPage } from './global/global.page';
import { LoginPage } from './login/login.page';
import { environment } from 'environments/environment.dev';
import { ApmService } from './services/apm.service';


@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
 
  constructor(public global: GlobalPage,private apmService :ApmService) { }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = 'my-token-string-from-server';
    const startTime = Date.now();
    let span: any = null;
   
    // Start APM span for HTTP request tracking
    if (this.apmService.isActive()) {
      const transaction = this.apmService.getCurrentTransaction();
      if (transaction) {
        span = this.apmService.startSpan(
          `${request.method} ${this.getEndpointName(request.url)}`,
          'external.http'
        );
        if (span) {
          span.addLabels({
            'http.method': request.method,
            'http.url': request.url
          });
        }
      }
    }
   
    request = request.clone({
      url: environment?.apiUrl+ request?.url,
      setHeaders: {
        Authorization: `Bearer ${this.global.authtoken}`,
        AgencyId: this.global.agencyId != "" ? this.global.agencyId : "",
        TimezoneId: (this.global.globalheaderTimeZone == null || this.global.globalheaderTimeZone == '') ? "" : this.global.globalheaderTimeZone
      },
      withCredentials: true
    })
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            const duration = Date.now() - startTime;
            
            // Add success labels to span
            if (span) {
              span.addLabels({
                'http.status_code': event.status,
                'http.response_time': duration
              });
            }
          }
        }
      ),
      catchError((error: HttpErrorResponse) => {
        const duration = Date.now() - startTime;
        
        // Add error labels to span
        if (span) {
          span.addLabels({
            'http.status_code': error.status,
            'http.response_time': duration,
            'error': true
          });
        }

        // Capture error in APM
        this.apmService.captureError(
          new Error(`HTTP ${error.status} - ${error.message}`),
          {
            url: request.url,
            method: request.method,
            statusCode: error.status,
            statusText: error.statusText
          }
        );

        return throwError(error);
      }),
      finalize(() => {
        // End the span
        if (span) {
          span.end();
        }
      })
    );
  }


  private getEndpointName(url: string): string {
    try {
      const urlObj = new URL(url);
      return urlObj.pathname.split('/').filter(p => p).slice(-2).join('/');
    } catch {
      return url.split('/').slice(-2).join('/');
    }
  }

  }



